import React, {useEffect, useState} from "react";
import testService from "../../../services/test.service";
import lessonService from "../../../services/lesson.service";
import ResultQuestionList from "./ResultQuestionList";
import theme from "../../../theme";
import Loading from "../../helper/Loading";
import withUrlParams from "../../HOC/withUrlParams";
import withErrorMessage from "../../HOC/withErrorMessage";
import withAuth from "../../HOC/withAuth";
import i18n from 'i18next';
import {useRecoilValue} from "recoil";
import {isOnlineState} from "../../../states/states";
import CustomSweetAlert from "../../helper/CustomSweetAlert";

const ResultDetailLayout = (props) => {
    const {handleError, testCode, lessonCode, tryTime, accessToken} = props;
    const [resultDetail, setResultDetail] = useState([]);
    const isOnline = useRecoilValue(isOnlineState);

    useEffect(() => {
        queryData();
    }, []);

    const queryData = () => {
        if (testCode && isOnline) {
            testService.getTestResultDetail(testCode, tryTime, accessToken)
                .then(response => {
                    if (response.data) {
                        setResultDetail(response.data);
                    }
                })
                .catch((error) => {
                    handleError(error, "getTestResultDetail")
                });
        }
        if (lessonCode && isOnline) {
            lessonService.getLessonResultDetail(lessonCode, tryTime, accessToken)
                .then(response => {
                    if (response.data) {
                        setResultDetail(response.data);
                    }
                })
                .catch((error) => {
                    handleError(error, "getLessonResultDetail")
                });
        }
    };

    const RenderResultPage = () => {
        if (resultDetail && resultDetail.questions && resultDetail.questions.length > 0) {
            return (
                <div style={{padding: theme.rootPadding}}>
                    <ResultQuestionList questions={resultDetail.questions} testTypeId={resultDetail.testTypeId}/>
                </div>
            );
        } else if (resultDetail && resultDetail.questions && resultDetail.questions.length === 0) {
            return <h6 className="no-result-detail"><p>{i18n.t('no_results_yet')}.</p></h6>;
        } else if(!isOnline) {
            return <CustomSweetAlert show={true} text={i18n.t('NO_NETWORK')} showConfirm={false}/>;
        }
        return <Loading/>
    };

    return (
        <RenderResultPage/>
    );
};

export default withUrlParams(withAuth(withErrorMessage(ResultDetailLayout)));